import React from 'react'
import { Card, Image } from "semantic-ui-react";
import noAvatar from "../../../../assets/png/icoeduca360.png";
import "./InfoStudent.scss";

export  function InfoStudent({ accessToken, student }) {
  //console.log(accessToken, student)
  return (
   
          <Card key={student._id} className="my-student-card">
            {/* Parte superior: avatar centrado */}
            <Card.Content className="card-top">
              <div className="student-avatar-wrapper">
                <Image
                  src={student.avatar || noAvatar}
                  alt="Student Avatar"
                  size="tiny"
                  circular
                  className="student-avatar"
                />
               
              </div>
            </Card.Content>

            {/* Nombre del Teacher y ClassNumber */}
            <Card.Content>
              <Card.Header textAlign="center">{student.name}{student.surname}</Card.Header>
              <Card.Meta textAlign="center">
                Clase: {student.classnumber || "N/A"}
              </Card.Meta>
            </Card.Content>
          </Card>
        );
      }
    

